import {createEntityAdapter, createSlice, current} from "@reduxjs/toolkit";
import {rxInit} from "./appSlice";
import {rxSubmitCarEditor} from "./carsSlice";

const mileageLogsAdapter = createEntityAdapter({
  sortComparer: (a, b) => {
    if (b.valueDate > a.valueDate) {
      return 1;
    } else if (b.valueDate < a.valueDate) {
      return -1;
    }

    return b.createTime.localeCompare(a.createTime);
  }
});

const initialState = {
  mileageLogs: mileageLogsAdapter.getInitialState(),

  list: {
    selectedCarId: null,
    inactiveCars: false
  },

  editor: {
    show: false,
    mode: null,
    deleteConfirmationModal: false
  }
};

export const computeMileageLogs = mileageLogs => {
  const mileageLogsByCar = {};

  mileageLogs.toReversed().forEach(log => {
    if (!mileageLogsByCar[log.car]) {
      mileageLogsByCar[log.car] = [];
    }

    mileageLogsByCar[log.car].push(log);
  })

  Object.values(mileageLogsByCar).forEach(logs => {
    let fullDistance = 0, fullQuantity = 0;

    for (let i = 1; i < logs.length; i++) {
      const log = logs[i];
      const previousMileageLog = logs[i - 1];

      log.distance = log.odometer - previousMileageLog.odometer;

      if (log.full) {
        let index = i - 1;
        let quantity = log.quantity;
        let distanceToFull = 0;

        fullQuantity += log.quantity;

        while (index >= 0) {
          const previousMileageLog = logs[index];

          if (previousMileageLog.full) {
            distanceToFull = log.odometer - previousMileageLog.odometer;
            fullDistance += distanceToFull;

            log.conso = quantity / distanceToFull * 100;
            log.averageConso = fullQuantity / fullDistance * 100;

            break;
          } else {
            quantity += previousMileageLog.quantity;

            fullQuantity += previousMileageLog.quantity;
          }

          index--;
        }
      }
    }
  });

  return mileageLogs;
}

export const mileageLogsSlice = createSlice({
  name: "mileageLogs",
  initialState,
  reducers: {
    showEditor: (state, action) => {
      state.editor.show = true;
      state.editor.mode = action.payload.mode;
      state.editor.mileageLog = action.payload.mileageLog;
      state.editor.deleteConfirmationModal = false;
    },

    hideEditor: state => {
      state.editor.show = false;
      state.editor.deleteConfirmationModal = false;
    },

    showHideDeleteConfirmationModal: (state, action) => {
      state.editor.deleteConfirmationModal = action.payload;
    },

    toggleSelectedCar: (state, action) => {
      state.list.listKey++;
      state.list.selectedCarId = action.payload.car.id;
    },

    toggleInactiveCars: (state) => {
      state.list.inactiveCars = !state.list.inactiveCars;
    },

    updateMileageLogs: (state, action) => {
      mileageLogsAdapter.setMany(state.mileageLogs, action.payload.umileageLogs || []);
      mileageLogsAdapter.removeMany(state.mileageLogs, action.payload.dmileageLogs || []);

      const logs = mileageLogsAdapter.getSelectors().selectAll(current(state).mileageLogs);

      mileageLogsAdapter.setMany(state.mileageLogs, computeMileageLogs(JSON.parse(JSON.stringify(logs))));
    }
  },
  extraReducers: builder => {
    builder.addCase(rxInit, (state, action) => {
      mileageLogsAdapter.setMany(state.mileageLogs, computeMileageLogs(action.payload.mileageLogs));

      if (action.payload.cars.length > 0) {
        state.list.selectedCarId = action.payload.cars.find(c => c.default).id;
      }
    });

    builder.addCase(rxSubmitCarEditor, (state, action) => {
      if (!state.list.selectedCarId) {
        state.list.selectedCarId = action.payload[0].id
      }
    });
  }
});

export const {
  showEditor: rxShowMileageLogEditor,
  hideEditor: rxHideMileageLogEditor,
  updateMileageLogs: rxUpdateMileageLogs,
  showHideDeleteConfirmationModal: rxShowHideDeleteConfirmationModal,

  toggleSelectedCar: rxToggleSelectedCar,
  toggleInactiveCars: rxToggleInactiveCars
} = mileageLogsSlice.actions;

export const {selectAll: selectAllMileageLogs} = mileageLogsAdapter.getSelectors(state => state.mileageLogs.mileageLogs);

export const listConfigSelector = state => state.mileageLogs.list;
export const editorConfigSelector = state => state.mileageLogs.editor;

export default mileageLogsSlice.reducer;
